import Vue from 'vue'
import VueRouter from 'vue-router'
import Content from '../layouts/Content.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/video',
    name: 'Video',
    meta: {
      title: '视频推荐'
    },
    component: () => import('../layouts/Video')
  },
  {
    path: '/',
    name: 'Home',
    meta: {
      requiresAuth: true,
      title: '方正云阅读'
    },
    component: () => import('../layouts/Home')
  },
  {
    path: '/upload',
    name: 'Upload',
    meta: {
      requiresAuth: true,
      title: '电子书刊'
    },
    component: () => import('../layouts/Make')
  },
  {
    path: '/list',
    name: 'list',
    meta: {
      requiresAuth: true,
      title: '电子书刊'
    },
    component: () => import('../layouts/List')
  },
  {
    path: '/personal',
    name: 'personal',
    meta: {
      requiresAuth: false,
      title: '个人主页'
    },
    component: () => import('../layouts/PersonalPage')
  },
  {
    path: '/subAccount',
    name: 'SubAccountManagement',
    meta: {
      requiresAuth: true,
      title: '子账号管理'
    },
    component: () => import('../layouts/SubAccountManagement')
  },
  {
    path: '/book',
    name: 'bookDefault',
    meta: {
      requiresAuth: true,
      title: ''
    },
    component: Content
  },
  {
    path: '/paper',
    name: 'paperDefault',
    meta: {
      requiresAuth: true,
      title: ''
    },
    component: Content
  },
  {
    path: '/digital',
    name: 'digital',
    meta: {
      requiresAuth: true,
      title: ''
    },
    component: () => import('../layouts/Digital')
  },
  {
    path: '/digitalArticle',
    name: 'digitalArticle',
    meta: {
      requiresAuth: true,
      title: ''
    },
    component: () => import('../layouts/DigitalArticle')
  },
  {
    path: '/digitalArticleMobile',
    name: 'digitalArticleMobile',
    meta: {
      requiresAuth: true,
      title: ''
    },
    component: () => import('../layouts/DigitalArticleMobile')
  },
  {
    path: '/agreement',
    name: 'Agreement',
    meta: {
      requiresAuth: true,
      title: '电子书刊'
    },
    component: () => import('../views/Agreement')
  },
  {
    path: '/content',
    name: 'contentDefault',
    meta: {
      requiresAuth: false,
      title: ''
    },
    component: Content
  },
  {
    path: '/paperContent',
    name: 'paperContentDefault',
    meta: {
      requiresAuth: false,
      title: ''
    },
    component: Content
  },
  {
    path: '/bookshelfdetail',
    name: 'bookshelfDetail',
    meta: {
      requiresAuth: false,
      title: '电子书刊'
    },
    component: () => import('../views/BookshelfDetail')
  },
  {
    path: '/paperSharePage',
    name: 'paperSharePage',
    meta: {
      requiresAuth: false,
      title: '数字报纸'
    },
    component: () => import('../views/PaperSharePage')
  },
  {
    path: '/paperArticleShare',
    name: 'paperArticleShare',
    meta: {
      requiresAuth: false,
      title: '报纸文章库'
    },
    component: () => import('../views/PaperArticleShare')
  },
  {
    path: '/shelfEdit',
    name: 'shelfEdit',
    meta: {
      requiresAuth: true,
      title: '电子书刊'
    },
    component: () => import('../views/shelfEdit')
  },
  {
    path: '/openVIP',
    name: 'openVIP',
    meta: {
      requiresAuth: true,
      title: '电子书刊'
    },
    component: () => import('../views/openVIP')
  },
  {
    path: '/bookLibdetail',
    name: 'bookLibdetail',
    meta: {
      requiresAuth: false,
      title: '电子书刊'
    },
    component: () => import('../views/BookLibDetail')
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    meta: {
      requiresAuth: true,
      title: '关于我们'
    },
    component: () => import('../layouts/aboutUs')
  },
  {
    path: '/goPayPage',
    name: 'GoPayPage',
    meta: {
      requiresAuth: true,
      title: '电子书刊'
    },
    component: () => import('../views/goPayPage')
  },
  {
    path: '/paperTurn',
    name: 'PaperTurn',
    meta: {
      requiresAuth: true,
      title: ''
    },
    component: Content
  },
  {
    path: '/paperContentTurn',
    name: 'PaperContentTurn',
    meta: {
      requiresAuth: false,
      title: ''
    },
    component: Content
  },
  {
    path: '/listen',
    name: 'Listen',
    meta: {
      requiresAuth: false,
      title: '听文章'
    },
    component: () => import('../views/listenArticle')
  },
  {
    path: '/topicArticleList',
    name: 'TopicArticleList',
    meta: {
      requiresAuth: false,
      title: '专题'
    },
    component: () => import('../views/topicArticleList')
  },
  {
    path: '/none/:code',
    name: 'none',
    meta: {
      requiresAuth: false,
      title: '无权限'
    },
    component: () => import('../views/none')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/elecPublish/',
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  let url = window.location.href
  if (url.includes('?from=')) {
    // 判断是否携带了 from 参数，这一步灵活变通，只要能判断出是从微信分享链接进来的就 OK
    url = url.replace(/index.+./, 'index.html') // 利用正则表达式去掉微信携带的 ?from=singlemessage&isappinstalled=0 这串参数，如果这串参数对于你当前的页面有用处的话，可以重新拼接到你正常的链接后面去
    window.location.href = url // 重定向到正常链接
  }
  next()
})

export default router
